import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ITradeCroppingRecord } from '../../../interfaces/trades/trade-cropping-record.model';
import { ITradeHeader } from '../../../interfaces/trades/trade-header.model';
import { IFilter } from '../../models/filter.model';
import { ISelectList } from '../../models/select-list.model';
import { ApiService } from '../api/api.service';
import { SeasonService } from '../season/season.service';

@Injectable()
export class TradeCroppingRecordsService {
  allCroppingRecords: Array<ITradeCroppingRecord> = [];
  fieldFilterOptions: Array<ISelectList> = [];

  constructor(
    private apiService: ApiService,
    private seasonService: SeasonService
  ) {}

  getCroppingRecords(
    header: ITradeHeader,
    fieldFilter: IFilter,
    stockPeriodId?: number
  ): Promise<ITradeCroppingRecord[]> {
    let url = 'v1/lookups:trades-lookups?';

    url += !_.isNil(stockPeriodId)
      ? `stockPeriodId=${stockPeriodId}`
      : `seasonId=${this.seasonService.displaySeasonForOrganisation()}`;

    if (fieldFilter.filterText) {
      url += `&filteroption=${fieldFilter.filterOption}&filtertext=${fieldFilter.filterText}`;
    }

    return this.apiService
      .get(url)
      .then((response: ITradeCroppingRecord[]) => response);
  }

  saveTradeCroppingRecords(
    header: ITradeHeader,
    croppingRecords: ITradeCroppingRecord[]
  ): Promise<any> {
    return this.apiService.put(
      `v1/miscellaneoustrades/${header.businessId}/croppingrecords/${header.id}`,
      croppingRecords
    );
  }
}
